<template>
    <sections>
        <app-subheader title="Event" :parent="{title: 'Home', route: '/'}" :dark="true">
            <button-subheader
                v-if="isAdmin && event"
                buttonIcon="edit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.event + event.id_event"
                :dark="true"
            ></button-subheader>
        </app-subheader>
        <section-jumbo
            v-if="event"
            color="bg-zinc-900"
            padding="py-20 sm:py-32 lg:py-32 xl:py-36 2xl:py-48"
            :image="event.event_jumbo ? $config.public.images + event.event_jumbo : null"
            imageOpacity="opacity-40"
            imagePosition="object-top"
            :heading="event.event_title"
            headingColor="text-white"
            :content="jumboContent"
            contentColor="text-zinc-100"
        ></section-jumbo>
        <section-cards
            v-if="event && videos?.length"
            :contentful="true"
            padding="py-10"
            heading="Videos"
            :cards="
                videos.map((video) => {
                    return {
                        route: useContextVideo().route(video),
                        image: video.video_thumb_url,
                        heading: video.video_title_placing,
                        excerpt: video.video_excerpt,
                    };
                })
            "
        ></section-cards>
        <section-text
            v-if="event && videos?.length === 0"
            color="bg-zinc-900"
            heading="Coming Soon"
            headingColor="text-zinc-100"
            headingComponent="h2"
            content="<p>Videos are inbound, please check back soon!</p>"
            contentColor="text-zinc-300"
        ></section-text>
        <section-jumbo
            v-if="event && event.event_website && event.event_description"
            color="bg-black"
            padding="py-20 sm:py-24 md:py-16 xl:py-20 2xl:py-24"
            :image="$config.public.images + event.event_jumbo"
            imageOpacity="opacity-20"
            :heading="event.event_title"
            headingColor="text-white"
            headingComponent="h2"
            :content="event.event_description"
            contentColor="text-zinc-100"
            buttonText="Event Website"
            :buttonUrl="event.event_website"
        ></section-jumbo>
        <section-text
            v-else-if="event"
            color="bg-zinc-920"
            heading="Learn West Coast Swing!"
            headingColor="text-zinc-200"
            headingComponent="h2"
            content="<article-learn-swing />"
            contentColor="text-zinc-400"
            buttonText="Search Classes"
            buttonRoute="/classes"
        ></section-text>
        <section-text
            v-if="error"
            heading="404 Not Found"
            headingColor="text-zinc-200"
            content="<p>Apologies, but we can't find that event.</p>"
            contentColor="text-zinc-400"
        ></section-text>
        <loading-spinner v-if="event === null && !error"></loading-spinner>
    </sections>
</template>

<script setup>
const eventSlug = useRoute().params.eventSlug;

const {isAdmin} = storeToRefs(useStoreAuth());

const {event, videos, error} = storeToRefs(useStoreEvent());
const {getEvent} = useStoreEvent();

await useLazyAsyncData('getEvent' + eventSlug, () => getEvent(eventSlug).then(() => true));

useSeoEvent().buildReactiveHead(event, error);

const jumboContent = computed(() => {
    if (!event.value.event_website || !event.value.event_state) return null;
    return `<p><a href='${event.value.event_website}' target='_blank'>Website</a> - ${event.value.event_city}, ${event.value.event_state}</p>`;
});
</script>
